export const formatSum = (sum: number): string => {
  let str = sum.toString();
  return str.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
};
